














import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'

import Coordinate from '@/interfaces/Coordinate'
import PricedCar from '@/classes/PricedCar'
import HertzPricedCar from '@/classes/Hertz/HertzPricedCar'

export default defineComponent({
  props: {
    coordinate: {
      type: Object as PropType<Coordinate | null>,
      default: null,
    },
    car: {
      type: Object as PropType<PricedCar | HertzPricedCar | null>,
      default: null,
    },
    count: {
      type: Number as PropType<number | null>,
      default: null,
    },
    hover: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    returnOrRent: {
      type: String,
      default: 'rent',
    },
    highlight: {
      type: Boolean,
      default: false,
    },
  },
  setup (props, { emit }) {
    const checkReturnOrNotOnMap = () => {
      emit('check-return-or-not-on-map', props.returnOrRent)
    }

    const minPrice = computed(() => {
      if (props.car instanceof HertzPricedCar) {
        return `${props.car.currency} ${props.car.price}`
      } else if (props.car instanceof PricedCar) {
        return props.car.price.fullFormattedValue
      }
      return ''
    })

    return {
      checkReturnOrNotOnMap,

      minPrice,
    }
  },
})
